import React from "react";
import songStyle from "./styles";
import { Box, Typography, Button } from "@mui/material";
import auth from "../Layout/util/auth";
import { enquireNowGTMCTAClick } from "../../util/gtmutil";
import { useSelector } from "react-redux";
import cookie from "js-cookie";

const AppDownload = (props) => {
  const r = auth();
  const { userData } = useSelector((state) => state.user);

  return (
    <Box id="Appdownload" sx={songStyle.FAQSection}>
      <Box>
        <Typography component="h1" sx={songStyle.AppdownloadHeading}>
          Stay updated with your
        </Typography>
        <Typography component="h1" sx={songStyle.AppdownloadHeading}>
          investments & new drops
        </Typography>

        <Box sx={songStyle.AppdownloadDesc}>
          <Typography component="p">Join the music revolution</Typography>
          <Button
            onClick={() => {
              enquireNowGTMCTAClick(
                r,
                "ctaClicks",
                "loggedIn",
                "Guest",
                "Download FanTiger App",
                userData?.mobile,
                userData?.email,
                cookie.get("_gid")
              );
              window.open(
                "https://play.google.com/store/apps/details?id=com.fantiger",
                "_blank"
              );
            }}
          >
            Download FanTiger App
          </Button>
        </Box>
        <Box
          sx={songStyle.AppdownloadImage}
          component="img"
          src="/images/home/DownloadApp.jpg"
        />
      </Box>
    </Box>
  );
};

export default AppDownload;
